module.exports = __webpack_public_path__ + "static/media/ir.e0c52ad2.webp";